import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Api from "../../utils/api";
import { setRoute } from "../../store/actions/routeActions";
import { useDispatch } from "react-redux";
import { SkeletonTable } from "../../components/Skeleton";

interface ISalida {
  AEREO_AEROPUERTO: string;
  AEREO_COMPANIA: string;
  AEREO_RESERVA: string;
  AEREO_VUELO: string;
  DONDE: string;
  ESTADO: string;
  FECHA: string;
  HORA: string;
  N_ORDEN: string;
  TRAMO: string;
}

const TdLugarYHorarioDeSalida = ({ etapa }: { etapa: ISalida }) => {
  if (etapa.TRAMO === "PARTIDA" || etapa.TRAMO === "ARRIBO") {
    return (
      <tr>
        <td>{etapa.TRAMO}</td>
        <td>
          Compañia: {etapa.AEREO_COMPANIA}
          <br />
          Reserva: {etapa.AEREO_RESERVA}
          <br />
          Número de Vuelo: {etapa.AEREO_VUELO}
          <br />
          Aeropuerto: {etapa.AEREO_AEROPUERTO}
        </td>
        <td>{etapa.FECHA}</td>
        <td>{etapa.HORA}</td>
        <td>{etapa.ESTADO}</td>
      </tr>
    );
  }

  return (
    <tr>
      <td>{etapa.TRAMO}</td>
      <td>{etapa.DONDE}</td>
      <td>{etapa.FECHA}</td>
      <td>{etapa.HORA}</td>
      <td>{etapa.ESTADO}</td>
    </tr>
  );
};

export default function LugarYHorarioDeSalida() {
  const [salida, setSalida] = useState<Array<ISalida>>([]);
  const [regreso, setRegreso] = useState<Array<ISalida>>([]);
  const [onLoad, setOnLoad] = useState(true);

  const { id = "-1" } = useParams();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      setRoute({
        section: "pasajero",
        sub: "lugar-horario-salida",
        cp: id,
      })
    );
  }, [dispatch, id]);

  useEffect(() => {
    Api("consumir")
      .post({
        servicio: "paxSalida",
        param: {
          pco_pasajero: id,
        },
      })
      .then((res) => {
        setOnLoad(false);
        setSalida(
          res.PCUR_SALIDA.sort((a: ISalida, b: ISalida) =>
            a.N_ORDEN > b.N_ORDEN ? 1 : -1
          )
        );
        setRegreso(
          res.PCUR_REGRESO.sort((a: ISalida, b: ISalida) =>
            a.N_ORDEN > b.N_ORDEN ? 1 : -1
          )
        );
      });
  }, [id]);

  return (
    <div className="container-data table-responsive">
      {onLoad ? (
        <>
          <SkeletonTable />
          <SkeletonTable />
        </>
      ) : (
        <>
          <table className="table table-striped text-center">
            <thead>
              <tr className="th-platform">
                <th>Salida</th>
                <th>Ubicación</th>
                <th>Fecha</th>
                <th>Horario</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {salida.map((etapa) => (
                <TdLugarYHorarioDeSalida key={etapa.N_ORDEN} etapa={etapa} />
              ))}
            </tbody>
          </table>
          <table className="table table-striped text-center mt-5">
            <thead>
              <tr className="th-platform">
                <th>Salida</th>
                <th>Ubicación</th>
                <th>Fecha</th>
                <th>Horario</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {regreso.map((etapa) => (
                <TdLugarYHorarioDeSalida etapa={etapa} key={etapa.N_ORDEN} />
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
